import PropTypes from 'prop-types';
import React from 'react';
import BrandImage from 'components/receipt/commons/BrandImage';
import RefundInfoBox from 'components/receipt/transactions/InfoBox/RefundInfoBox';
import RefundReason from 'components/receipt/transactions/RefundReason';
import RefundListItemBox from 'components/receipt/transactions/ListItemBox/RefundListItemBox';
import ListItemBox from 'components/receipt/transactions/ListItemBox/ListItemBox';
import RefundCountingBox from 'components/receipt/transactions/CountingBox/RefundCountingBox';
import CountingBox from 'components/receipt/transactions/CountingBox/CountingBox';
import RefundTotal from 'components/receipt/transactions/Total/RefundTotal';
import Total from 'components/receipt/transactions/Total/Total';
import InfoBox from 'components/receipt/transactions/InfoBox/InfoBox';
import LoyaltyInfo from 'components/receipt/commons/LoyaltyInfo';
import RefundedLoyaltyInfo from 'components/receipt/commons/RefundedLoyaltyInfo';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './TransactionDetailReceipt.css';

class TransactionDetailReceipt extends React.Component {
  render() {
    const { paymentDetail, enableReceiptLogoPerOutlet } = this.props;

    return (
      paymentDetail != null && (
        <div className={styles['receipt-scrolled-area']} id="receipt">
          {paymentDetail.receipt_count && paymentDetail.receipt_count > 0 ? (
            <i
              className={`glyphicon glyphicon-info-sign ${
                styles['reprinted-receipt']
              }`}
            >
              <span className={`${styles['reprinted-text']}`}>
                This receipt has been reprinted
              </span>
            </i>
          ) : (
            ''
          )}
          {paymentDetail.payment_refunds &&
            paymentDetail.payment_refunds.map((paymentRefund, i) => (
              <div key={i}>
                {paymentDetail.payment_refunds.length > 0 && (
                  <div className={styles['receipt-inner-box']}>
                    <div className={styles['refund-title']}>Refund</div>
                    <div id="show-transaction-page">
                      <BrandImage
                        businessLogo={
                          enableReceiptLogoPerOutlet
                            ? paymentDetail.outlet_logo
                              ? paymentDetail.outlet_logo
                              : paymentDetail.business_logo
                            : paymentDetail.business_logo
                        }
                        businessName={
                          enableReceiptLogoPerOutlet
                            ? paymentDetail.outlet_logo
                              ? paymentDetail.outlet_name
                              : paymentDetail.business_name
                            : paymentDetail.business_name
                        }
                        outletAddress={paymentDetail.outlet_address}
                        outletPhone={paymentDetail.outlet_phone}
                      />
                      <RefundInfoBox
                        paymentDetail={paymentDetail}
                        paymentRefund={paymentRefund}
                      />
                      <RefundReason paymentRefund={paymentRefund} />
                      <RefundListItemBox paymentRefund={paymentRefund} />
                      <RefundCountingBox
                        paymentDetail={paymentDetail}
                        paymentRefund={paymentRefund}
                      />
                      <RefundTotal amount={paymentRefund.refund_amount} />
                      {paymentRefund.loyalty &&
                        Object.keys(paymentRefund.loyalty).length && (
                          <RefundedLoyaltyInfo
                            loyalty={paymentRefund.loyalty}
                            memberPhone={paymentDetail.customer_phone}
                          />
                        )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          <div
            className={`${styles['receipt-inner-box']} ${
              paymentDetail.payment_refunds &&
              paymentDetail.payment_refunds.length === 0
                ? styles['remove-padding']
                : ''
            }`}
          >
            <BrandImage
              businessLogo={
                enableReceiptLogoPerOutlet
                  ? paymentDetail.outlet_logo
                    ? paymentDetail.outlet_logo
                    : paymentDetail.business_logo
                  : paymentDetail.business_logo
              }
              businessName={
                enableReceiptLogoPerOutlet
                  ? paymentDetail.outlet_logo
                    ? paymentDetail.outlet_name
                    : paymentDetail.business_name
                  : paymentDetail.business_name
              }
              outletAddress={paymentDetail.outlet_address}
              outletPhone={paymentDetail.outlet_phone}
            />
            <InfoBox paymentDetail={paymentDetail} />
            <ListItemBox paymentDetail={paymentDetail} />
            <CountingBox paymentDetail={paymentDetail} />
            <Total paymentDetail={paymentDetail} />
            {paymentDetail.loyalty &&
              Object.keys(paymentDetail.loyalty).length && (
                <LoyaltyInfo
                  loyalty={paymentDetail.loyalty}
                  memberPhone={paymentDetail.customer_phone}
                  isUnpaidInvoice={false}
                />
              )}
          </div>
          <div
            className={[
              `receipt-header-status`,
              paymentDetail.total_collected >
              paymentDetail.total_amount_received
                ? 'header-status-red'
                : 'header-status-orange',
            ].join(' ')}
          />
        </div>
      )
    );
  }
}

TransactionDetailReceipt.propTypes = {
  paymentDetail: PropTypes.object,
};

const mapFlagsToProps = flags => {
  return {
    enableReceiptLogoPerOutlet: flags.receiptLogoPerOutlet,
  };
};

export default withFeatureFlags(mapFlagsToProps)(TransactionDetailReceipt);
